import { ITimelineItem } from '../../../store/videoEditor/videoEditor.types';

export const getTimelineLayerVisualType = (acceptTypes: ITimelineItem['type'][]) => {
  return acceptTypes.includes('audio') ? 'audio' : 'visual';
};
